import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-4 col-sm-6" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = { class: "col-lg-2 col-sm-6" }
const _hoisted_8 = { class: "form-group mb-4" }
const _hoisted_9 = { value: null }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-lg-6 col-sm-6 text-end mt-4" }
const _hoisted_12 = { class: "d-inline-flex flex-wrap gap-3 justify-content-end" }
const _hoisted_13 = { class: "default-table-area style-two default-table-width" }
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "table align-middle" }
const _hoisted_16 = { class: "text-body" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "p-4 pt-lg-4" }
const _hoisted_21 = {
  id: "mdlNotificationSchedules",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlNotificationSchedulesLabel",
  "aria-hidden": "true",
  size: "large",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_22 = { class: "modal-dialog modal-lg" }
const _hoisted_23 = { class: "modal-content" }
const _hoisted_24 = { class: "modal-body" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-6 col-sm-6" }
const _hoisted_27 = { class: "form-group mb-4" }
const _hoisted_28 = { class: "input-error" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-lg-6 col-sm-6" }
const _hoisted_31 = { class: "form-group mb-4" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_35 = {
  key: 2,
  role: "status"
}
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "default-table-area style-two" }
const _hoisted_38 = { class: "table-responsive" }
const _hoisted_39 = { class: "table align-middle" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "label text-secondary" }, "Asunto", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.subject) = $event)),
                    class: "form-control h-45",
                    placeholder: "Ingrese asunto"
                  }, null, 512 /* NEED_PATCH */), [
                    [
                      _vModelText,
                      _ctx.filters.subject,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label text-secondary" }, "Tipo", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.typeId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsNotificationTypes, (notificationType, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: notificationType.id,
                        key: i
                      }, _toDisplayString(notificationType.name), 9 /* TEXT, PROPS */, _hoisted_10))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.typeId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.getNotifications(_ctx.currentPage)), ["prevent"])),
                    class: "btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                  }, " Buscar ")
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("table", _hoisted_15, [
              _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "#"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Asunto"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Tipo"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode("creación")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Opciones")
                ])
              ], -1 /* HOISTED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1 + (_ctx.currentPage - 1) * _ctx.pageSize), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.subject), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.typeStr), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(item.createdAtDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_RouterLink, {
                          to: `/notification/edit/${item.id}`
                        }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " edit ", -1 /* HOISTED */)
                          ]))]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                        _createElementVNode("button", {
                          class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                          onClick: ($event: any) => (_ctx.notificationScheduleModal(item.id))
                        }, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " settings ", -1 /* HOISTED */)
                        ]))], 8 /* PROPS */, _hoisted_19)
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_Pagination, {
              currentPage: _ctx.currentPage,
              pageSize: _ctx.pageSize,
              totalItems: _ctx.totalItems,
              "onUpdate:page": _ctx.fetchPage
            }, null, 8 /* PROPS */, ["currentPage", "pageSize", "totalItems", "onUpdate:page"])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "mdlNotificationSchedulesLabel"
            }, " Fecha de Notificaciones ")
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("form", {
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label text-secondary strong" }, "Fecha", -1 /* HOISTED */)),
                    _createVNode(_component_VueDatePicker, {
                      placeholder: "Fecha y hora",
                      modelValue: _ctx.notificationSchedule.scheduleDate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.notificationSchedule.scheduleDate) = $event)),
                      format: "dd/MM/yyyy HH:mm",
                      "format-locale": _ctx.es,
                      onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearError('scheduleDate'))),
                      "minutes-increment": 1,
                      "enable-time-picker": true,
                      "is-24": "",
                      teleport: ""
                    }, null, 8 /* PROPS */, ["modelValue", "format-locale"]),
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.errors.scheduleDate), 1 /* TEXT */)
                  ])
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-lg-6 col-sm-6" }, [
                  _createElementVNode("div", { class: "form-group mb-4" })
                ], -1 /* HOISTED */))
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("button", {
                      class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4",
                      type: "submit",
                      disabled: _ctx.isLoading
                    }, [
                      (!_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.notificationSchedule.id == 0
                        ? "Crear Fecha"
                        : "Actualizar Fecha"), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34))
                        : _createCommentVNode("v-if", true),
                      (_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Procesando..."))
                        : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_32)
                  ])
                ])
              ])
            ], 32 /* NEED_HYDRATION */),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("table", _hoisted_39, [
                    _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { scope: "col" }, "#"),
                        _createElementVNode("th", {
                          scope: "col",
                          class: "text-center"
                        }, "Fecha Programada"),
                        _createElementVNode("th", {
                          scope: "col",
                          class: "text-center"
                        }, "Fecha Registro"),
                        _createElementVNode("th", {
                          scope: "col",
                          class: "text-center"
                        }, "Opciones")
                      ])
                    ], -1 /* HOISTED */)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationSchedules, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1 /* TEXT */),
                          _createElementVNode("td", null, _toDisplayString(item.scheduleDateTimeString), 1 /* TEXT */),
                          _createElementVNode("td", null, _toDisplayString(item.createdAtDateTimeString), 1 /* TEXT */),
                          _createElementVNode("td", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("button", {
                                class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                                onClick: ($event: any) => (_ctx.editNotificationSchedule(item))
                              }, [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " edit ", -1 /* HOISTED */)
                              ]))], 8 /* PROPS */, _hoisted_42),
                              _createElementVNode("button", {
                                class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                                onClick: ($event: any) => (_ctx.deleteNotificationSchedule(item.id))
                              }, [...(_cache[16] || (_cache[16] = [
                                _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " delete ", -1 /* HOISTED */)
                              ]))], 8 /* PROPS */, _hoisted_43)
                            ])
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeNotificationSchedule && _ctx.closeNotificationSchedule(...args)))
            }, " Cerrar ")
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}